module.exports = __webpack_public_path__ + "a95c37edf507598a25971dcfb70d847f.pdf";